import { render } from "./VICheckbox.vue?vue&type=template&id=7f5a519c&scoped=true"
import script from "./VICheckbox.vue?vue&type=script&lang=js"
export * from "./VICheckbox.vue?vue&type=script&lang=js"

import "./VICheckbox.vue?vue&type=style&index=0&id=7f5a519c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5a519c"]])

export default __exports__